import {Injectable} from '@angular/core';
import {ServerService} from '../services/server.service';
import {User, UserData} from "./User";
import {DataService} from "../services/data.service";
import {Piano} from "./Piano";
import {STATO_TRASFERIMENTO} from "./Ordine";


export class EsercizioData{
   public id?:number;
   public slug?:string;
   public display_name?:string;
   public ragione_sociale?:string;
   public piva?:number;
   public rea_cf?:string;
   public sdi?:string;
   public telefono?:number;
   public email?:string;
   public pec?:string;
   public sede_legale?:any;
   public is_approvato?:boolean;
   public enabled?:boolean;
   public visura_camerale?:any;
   public documento_legale_rapp?:any;
   public documento_contratto?:any;
   public documento_verifica?:any;
   public log_check_piva?:string;
   public amministratore?: any;
   public image?: string;
   public piano_esercizio__piano__id?:any;
   public piano_esercizio__start?:string;
   public piano_esercizio__end?:string;
   public piva_valid?:boolean;
}


@Injectable({
   providedIn: 'root'
})
export class EsercizioFactory {

   constructor(private serverSrv:ServerService,
               private dataSrv:DataService) {

   }

   public BASE_URL = "/api/esercizi"

   async getEsercizio(esercizio_id):Promise<Esercizio> {
      return new Promise<Esercizio>((resolve, reject) => {
         this.serverSrv.get(Esercizio,`/api/esercizi/${esercizio_id}`).then(esercizio=>{
            resolve(esercizio)
         }).catch(err=>{
            reject(err)
         })
      })
   }

   async editEsercizio(esercizio_id, data):Promise<Esercizio> {
      return new Promise<Esercizio>((resolve, reject) => {
         this.serverSrv.put(`/api/esercizi/${esercizio_id}`, data).then(esercizio=>{
            resolve(esercizio)
         }).catch(err=>{
            reject(err)
         })
      })
   }

   async getUtenteEsercizio(esercizio_id):Promise<User> {
      return new Promise<User>((resolve, reject) => {
         this.serverSrv.get(User,`/api/esercizi/${esercizio_id}/utente`).then(utente=>{
            resolve(utente)
         }).catch(err=>{
            reject(err)
         })
      })
   }

   async editUtenteEsercizio(esercizio_id, utente_id, data):Promise<User> {
      return new Promise<User>((resolve, reject) => {
         this.serverSrv.put(`/api/esercizi/${esercizio_id}/utenti/${utente_id}`, data, User).then(utente=>{
            resolve(utente)
         }).catch(err=>{
            reject(err)
         })
      })
   }

   uploadEsercizio(esercizio_id , files): Promise<boolean> {
      let url = `/api/esercizi/${this.dataSrv.esercizioUser.esercizio.ID}/uploadimage`
      return new Promise<boolean>((resolve, reject) => {
         this.serverSrv.uploadFile(url, files)
            .then(res=>{resolve(true)})
            .catch(err=>{reject(err)})
      })
   }

   async getEsercizi(user_id:any=null): Promise<Esercizio[]> {
      let url = ""

      if(!user_id){
         url = `${this.BASE_URL}`
      }else{
         url = `/api/utenti/${user_id}/esercizi`
      }

      return new Promise<Esercizio[]>((resolve, reject) => {
         this.serverSrv.getAll(Esercizio, url).then(res=>{
            resolve(res)
         }).catch(err=>{
            reject(err)
         })
      })
   }
}


export class Esercizio {
   public data: EsercizioData = {}
   ID!: number;
   id!: number;

   constructor(data:EsercizioData = {}) {
      if(!data) data = {}
      Object.assign(this.data, data);

      if (this.data.id != null) {
         this.ID = this.data.id;
      }
   }

   public static Tipo_Documento_Leg_Rapp = [
      {value:'CI', display:"Carta d'identità"},
      {value:'PP', display:"Passaporto"},
      {value:'PG', display:"Patente di guida"}
   ]

   public static Tipo_Documento_Verifica = [
      {value:'UD', display:"Utenza domestica (Luce, Gas, Telefono, ...)"},
      {value:'DB', display:"Documento bancario"},
   ]

   public static HeaderFilterLocaleGlobale = [{
      text: "Locale",
      value: false
   }, {
      text: "Globale",
      value: true
   }
   ];
}

// export class Tipo_Doc_Legale_Rapp:
